import styled from 'styled-components';

const HeaderWrapper = styled.div`
  .svg-circleplus {
    height: 38px;
    stroke: #1e3c81;
  }
`;
export default HeaderWrapper;
